import React, { FC } from 'react';
import { CrossIconvector, GreenTickAnimatedIcon } from 'assets/icons';
import { GenericModal } from 'components';
import { VoidFn } from 'types/baseTypes';
import { RelatedInvoiceForJob } from '../jobs.model';
import { InvoiceStatus } from 'containers/invoices/invoices.model';
import { getAmountWithCurrency } from 'utils/amountUtils';
import DateUtils from 'utils/dateUtils';

interface DoneStatusSuccessModalProps {
  onClose: VoidFn;
  onAddInvoiceClick: VoidFn;
  invoice: RelatedInvoiceForJob | null;
}

const DoneStatusSuccessModal: FC<DoneStatusSuccessModalProps> = ({ onAddInvoiceClick, onClose, invoice }) => {
  const getSecondaryText = () => {
    if (!invoice || invoice.status === InvoiceStatus.PENDING) {
      return 'Would you like to collect a payment for this job?';
    }
    return null;
  };

  const getTertiaryText = () => {
    if (invoice && invoice.status === InvoiceStatus.PENDING)
      return `${getAmountWithCurrency(invoice.amountPayable)} ${getPendingDays(invoice?.createdAt).toLowerCase()}`;
    return null;
  };

  const getPrimaryBtnText = () => {
    if (!invoice) return '+ Yes, add invoice';
    if (invoice && invoice.status === InvoiceStatus.PENDING) return 'Yes, view invoice';
    return 'View invoice';
  };

  const getPendingDays = (createdAt: string) => {
    const days = DateUtils.getDifferenceInDays({ secondaryDate: new Date(createdAt) });
    if (days === 0) {
      return 'pending today';
    }
    return `pending for ${days} day${days === 1 ? '' : 's'}`;
  };

  return (
    <GenericModal
      CloseIcon={CrossIconvector}
      showModal={true}
      isActionInProgress={false}
      MainIcon={GreenTickAnimatedIcon}
      className="px-4 py-[30px]"
      title="Job done! "
      subTitle={getSecondaryText()}
      primaryBtnId="status-success-modal-add-invoice"
      primaryBtnLabel={getPrimaryBtnText()}
      secondaryBtnId="status-success-modal-skip"
      secondaryBtnLabel="Skip"
      onPrimaryBtnClick={onAddInvoiceClick}
      onSecondaryBtnClick={onClose}
      titleStyle="text-17px font-semibold text-successHighlight mb-2"
      mainIconStyle="mb-4 h-[60px] w-[60px]"
      containerWidth="343px"
      subTitleStyle="text-xl font-semibold text-headingGray text-center pt-8 mb-0"
      primaryBtnStyle="h-12 my-4"
      secondaryBtnStyle="h-12 border-gray-1"
      tertiaryText={getTertiaryText()}
      tertiaryTextStyle="text-sbase text-headingGray text-center mt-2"
    />
  );
};

export default DoneStatusSuccessModal;
